type RequiredOrder = {order: number};
type OptionalOrder = {order?: number};

export const sortByOrder = <T extends RequiredOrder>(items: T[]): T[] => {
  return items.sort((a, b) => {
    return a.order - b.order;
  });
};

export const sortByOptionalOrder = <T extends OptionalOrder>(
  a: T,
  b: T,
  nullPosition: 'first' | 'last' = 'last',
): number => {
  const fallback = nullPosition === 'first' ? 0 : 9999;

  return (a.order ?? fallback) - (b.order ?? fallback);
};
